<!-- eslint-disable vue/no-mutating-props -->
<template>
  <card :title="computedTitle" :on-cancel="cancel">
    <Form ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(saveLocation)">
        <div class="row">
          <div class="col-md-4">
            <material-input-field
              id="addressInput"
              ref="addressInput"
              v-model="address"
              :name="'address'"
              variant="static"
              :label="$t('locations.address') + ' *'"
              :placeholder="$t('locations.address')"
            />
          </div>

          <div class="col-md-4">
            <label class="col-md-4 col-form-label">{{$t('common.type')}} *</label>
            <div class="row" style="padding-left: 18px;">
              <el-select
                v-if="selectedLocationType !== 'custom'"
                ref="locationTypeInput"
                v-model="selectedLocationType"
                filterable
                :class="selectClass"
                size="default"
                style="width: 365px;"
                :placeholder="$t('common.selectType')"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :class="selectClass"
                  :value="item.type"
                  :label="item.type"
                />
                <el-option
                  :class="selectClass"
                  value="custom"
                  :label="$t('common.addNewType')"
                />
              </el-select>

              <material-input-field
                v-if="selectedLocationType === 'custom'"
                id="newLocationTypeInput"
                ref="newLocationTypeInput"
                v-model="newLocationType"
                :name="'newLocationType'"
                style="width: 340px;"
                :placeholder="$t('common.type')"
              />
              <span v-if="selectedLocationType === 'custom'" class="cancel-new-type" @click="cancelNewLocationType">
                <i class="material-icons">close</i>
              </span>
            </div>
          </div>

          <div class="col-md-4" :style="{ paddingTop: !isMobile ? '40px' : '10px' }">
            <label class="form-check-label mb-0 me-2">
              <small id="requirePrecenceLabel">{{$t('locations.requirePresenceForToolReturn')}}</small>
            </label>
            <material-switch
              id="requirePrecence"
              v-model="requirePresenceForToolReturn"
              :name="$t('locations.requirePresenceForToolReturn')"
            />
          </div>
        </div>

        <hr v-if="isMobile">

        <div class="row">
          <div class="col-md-4">
            <material-input-field
              id="latitudeInput"
              v-model="latitude"
              :name="'latitude'"
              variant="static"
              :label="$t('locations.latitude')"
              :placeholder="$t('locations.latitude')"
            />
          </div>
          <div class="col-md-4">
            <material-input-field
              id="longitudeInput"
              v-model="longitude"
              :name="'longitude'"
              variant="static"
              :label="$t('locations.longitude')"
              :placeholder="$t('locations.longitude')"
            />
          </div>
          <div class="col-md-4">
            <material-input-field
              id="radiusInput"
              v-model="radius"
              :name="'radius'"
              variant="static"
              :label="$t('locations.radius')"
              :placeholder="$t('locations.radius')"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button variant="gradient" color="dark" @click="saveLocation">
              {{$t('common.submit')}}
            </material-button>
          </div>
        </div>
      </form>
    </Form>
  </card>
</template>
<script>
import api from "../../services/api"
import { ElSelect, ElOption } from 'element-plus';
import { Form } from 'vee-validate';
import Card from "../../components/Card.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import MaterialButton from "@/components/MaterialButton.vue";

export default {
  components: {
    ElSelect,
    ElOption,
    Form,
    Card,
    MaterialInputField,
    MaterialSwitch,
    MaterialButton
  },
  props: {
    editMode: {
      type: Boolean,
      required: true
    },
    longitudeProp: {
      type: String,
      required: false,
      default: null
    },
    latitudeProp: {
      type: String,
      required: false,
      default: null
    },
    addressProp: {
      type: String,
      required: false,
      default: null
    },
    selectedLocationTypeProp: {
      type: String,
      required: false,
      default: null
    },
    requirePresenceForToolReturnProp: {
      type: Boolean,
      required: false
    },
    editingLocationId: {
      type: Number,
      required: false,
      default: null
    },
    radiusProp: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['close', 'refresh-data'],
  data() {
    return {
      options: [],
      isMobile: window.innerWidth <= 1024,
      selectedLocationType: this.selectedLocationTypeProp,
      longitude: this.longitudeProp,
      latitude: this.latitudeProp,
      address: this.addressProp,
      newLocationType: '',
      requirePresenceForToolReturn: this.requirePresenceForToolReturnProp,
      radius: this.radiusProp
    };
  },
  computed: {
    computedTitle() {
      return this.editMode ? this.$t('locations.editLocation') : this.$t('locations.createLocation');
    },
    selectClass() {
      let darkMode = localStorage.getItem('darkMode');
      if (darkMode === null) {
        darkMode = 'false';
      }
      if (darkMode === 'false') {
        return 'select-standard';
      } else {
        return 'select-primary';
      }
    }
  },
  created() {
    this.fetchData();
    window.addEventListener('resize', this.updateIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  methods: {
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 1024;
    },
    cancelNewLocationType(){
      if(this.options.length>0){
        this.selectedLocationType = this.options[0].type
      }
      else{
        this.selectedLocationType = ''
      }
    },
    cancel()
    {
      this.$emit('close');
    },
    async saveLocation() {
      if (this.validateInput()) {
        let locationtypeid = 0
        if(this.newLocationType !== '')
        {
          const newLocationTypeResponse = await api.post('/LocationType', {
            type: this.newLocationType,
          });
          locationtypeid = newLocationTypeResponse.data.id
        }
        else
        {
          locationtypeid = this.options.filter(op => op.type === this.selectedLocationType)[0].id
        }
        if(this.latitude === ''){
          this.latitude = null
        }
        if(this.longitude === ''){
          this.longitude = null
        }
        if(this.radius === ''){
          this.radius = null
        }

        if(this.editMode)
        {
          try {
            await api.put('/Location/' + this.editingLocationId , {
              address: this.address,
              latitude: this.latitude,
              longitude: this.longitude,
              requirePresenceForToolReturn: this.requirePresenceForToolReturn,
              radiusMeters: this.radius,
              locationtypeid: locationtypeid
            });
            this.$toast.success(this.$t('locations.locationUpdated'), { timeout: 1500 });

            this.$emit('refresh-data');
            this.$emit('close');
          } catch (error) {
            console.error(error) // eslint-disable-line no-console
            this.$toast.error(`Unable to update location: ${error.message}`, { timeout: 0 });
          }
        }
        else
        {
          try {
            await api.post('/Location', {
              address: this.address,
              latitude: this.latitude,
              longitude: this.longitude,
              requirePresenceForToolReturn: this.requirePresenceForToolReturn,
              radiusMeters: this.radius,
              locationtypeid: locationtypeid
            });
            this.$toast.success(this.$t('locations.locationCreated'), { timeout: 1500 });

            this.$emit('refresh-data');
            this.$emit('close');
          } catch (error) {
            console.error(error) // eslint-disable-line no-console
            this.$toast.error(`Unable to create location: ${error.message}`, { timeout: 0 });
          }
        }
      }
    },
    fetchData()
    {
      let getLocationTypessUrl = `/LocationType`
      api.get(getLocationTypessUrl)
      .then(response => {
          this.options = response.data
      })
      .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.error(`Unable to retrieve location type data: ${error.message} <br> Please refresh the page`, { timeout: 0 });
      });
    },
    validateInput() {
      let success = true;
      if (this.address === '') {
        this.$toast.info(this.$t('errors.addressEmpty'), { timeout: 2500 });
        success = false;
      }
      else if (this.selectedLocationType === 'custom' && this.newLocationType === '') {
        this.$toast.info(this.$t('errors.newLocationTypeEmpty'), { timeout: 2500 });
        success = false;
      }
      else if (this.selectedLocationType === '') {
        this.$toast.info(this.$t('errors.locationEmpty'), { timeout: 2500 });
        success = false;
      }
      else if(this.checkIfNumber(this.latitude) === false || this.checkIfNumber(this.longitude) === false)
      {
        this.$toast.info(this.$t('errors.latLongMustBeNumber'), { timeout: 2500 });
        success = false;
      }
      else if(this.requirePresenceForToolReturn === true && (this.radius === '' || this.latitude === '' || this.longitude === ''))
      {
        this.$toast.info(this.$t('errors.radiusLatLongMustBeSetIfPresenceRequired'), { timeout: 2500 });
        success = false;
      }
      return success;
    },
    checkIfNumber(input) {
      if (!isNaN(input)) {
        return true
      } else {
        return false
      }
    }
  },
};
</script>
<style scoped>
.cancel-new-type {
  cursor: pointer;
  padding-left: 10px;
  padding-top: 10px;
}
.cancel-new-type i {
  font-size: 20px;
}
</style>
